export default __webpack_public_path__ + "fonts/Roboto-300-vietnamese5.woff2";